export enum types {
  CART_ADD_PRODUCT = 'cart/addProduct',
  CART_ADD_PRODUCTS = 'cart/addProducts',
  CART_PRODUCT_COUNT_CHANGED = 'cart/productCountChanged',
  CART_REMOVE_PRODUCT = 'cart/removeProduct',
  CART_MULTI_REMOVE_PRODUCTS = 'cart/multiRemoveProduct',
  CART_CLEAR_CART = 'cart/clear',
  CART_CART_IS_TO_BE_SAVED = 'cart/is_to_be_saved',
  CART_LOAD_CART_FROM_CACHE = 'cart/load_cart',
}